export default __webpack_public_path__ + "static/media/press_1.1244b6b2.jpg";